import { render, staticRenderFns } from "./AssignedBookings.vue?vue&type=template&id=67128dcb"
import script from "./AssignedBookings.vue?vue&type=script&lang=js"
export * from "./AssignedBookings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports